import { render, staticRenderFns } from "./StartTempTest.vue?vue&type=template&id=41fea7d2&scoped=true&"
import script from "./StartTempTest.vue?vue&type=script&lang=js&"
export * from "./StartTempTest.vue?vue&type=script&lang=js&"
import style0 from "./StartTempTest.vue?vue&type=style&index=0&id=41fea7d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fea7d2",
  null
  
)

export default component.exports